import { render, staticRenderFns } from "./scriptable-form.vue?vue&type=template&id=8cdccd1c&scoped=true&"
import script from "./scriptable-form.vue?vue&type=script&lang=ts&"
export * from "./scriptable-form.vue?vue&type=script&lang=ts&"
import style0 from "./scriptable-form.vue?vue&type=style&index=0&id=8cdccd1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdccd1c",
  null
  
)

export default component.exports